import { i18n } from '@investigator/shared/localization';
import { CommunicationDirection } from '../types/entityCommunication';

const { popover } = i18n.pages.entities.entityAnalysisModal.entityCommunication;

export const useEntityCommunicationPopover = ({
  direction,
}: {
  direction: CommunicationDirection;
}) => {
  const isInbound = direction === CommunicationDirection.INBOUND;

  return {
    title: isInbound ? popover.inboundTitle : popover.outboundTitle,
    columns: popover.columns,
    placement: isInbound ? ('bottom-start' as const) : ('bottom-end' as const),
    triggerPosition: isInbound
      ? ({ left: 0 } as const)
      : ({ right: 0 } as const),
  };
};
